import React from 'react';

export type CarouselRenderState = 'content' | 'empty' | 'loading';

type ReportCarouselRenderState = (renderState: CarouselRenderState) => void;

type CarouselRenderStateInput = {
  loading: boolean;
  hasContent: boolean;
};

const CarouselRenderStateContext = React.createContext<ReportCarouselRenderState | null>(null);

export const CarouselRenderStateProvider = CarouselRenderStateContext.Provider;

const useIsomorphicLayoutEffect = typeof window === 'undefined' ? React.useEffect : React.useLayoutEffect;

// Optional bridge for containers that reserve layout while an async carousel loads. Reusable
// carousels remain standalone because reporting is a no-op without an ancestor provider.
export function useReportCarouselRenderState({ loading, hasContent }: CarouselRenderStateInput): void {
  const reportRenderState = React.useContext(CarouselRenderStateContext);

  useIsomorphicLayoutEffect(() => {
    if (!reportRenderState) {
      return;
    }

    if (loading) {
      reportRenderState('loading');
      return;
    }

    reportRenderState(hasContent ? 'content' : 'empty');
  }, [hasContent, loading, reportRenderState]);
}
